import { useSelector } from 'react-redux';
import { selectSettings } from '@/store/bootstrap/selectors';

export const useIntegrations = () => {
  const settingsDetails = useSelector(selectSettings);

  return {
    isHackerRankEnabled: settingsDetails?.account?.connected_hackerrank,
    isHackerEarthEnabled: settingsDetails?.account?.connected_hackerearth,
    isCriteriaCorpEnabled: settingsDetails?.account?.connected_criteriacorp,
    isCheckrEnabled: settingsDetails?.account?.connected_checkr,
    isCertnEnabled: settingsDetails?.account?.connected_certn,
    isZincEnabled: settingsDetails?.account?.connected_zinc,
    isHireflixEnabled: settingsDetails?.account?.connected_hireflix,
    isCodeInterviewEnabled: settingsDetails?.account?.connected_codeinterview,
  };
};
